import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import ButtonCollapse from 'components/Widgets/ButtonCollapse';

export default function Steps({ programId, program }) {
  const sessionSteps = program.attributes.steps.filter((step) => step.step_type === 'session'
    || step.step_type === 'ai_session');

  const stepItem = (step) => (
    <li
      key={`${programId}-step-${step.id}`}
      className={step.predefined ? 'predefined' : ''}
    >
      {step.title}
    </li>
  );

  return (
    <Col md="6" className="main">
      <ol className="m-0 fw-light small">
        {sessionSteps.slice(0, 6).map((step) => stepItem(step))}

        {sessionSteps.length > 6 && (
        <div className={`${programId} collapse`}>
          {sessionSteps.slice(6).map((step) => stepItem(step))}
        </div>
        )}
      </ol>

      {sessionSteps.length > 6 && (
      <ButtonCollapse target={`.${programId}`} controls={programId} />
      )}
    </Col>
  );
}

Steps.propTypes = {
  programId: PropTypes.string.isRequired,
  program: PropTypes.object.isRequired,
};
